/* ==========================================================================
   Bold Grip Socks: in-place pack selector on single-sock product pages.
   Toggles Single / 2 / 4 / 6 / 10 without navigating. Choosing a pack reveals a
   colour picker built from window.BM_COLORWAYS (every colour in the "colorways"
   collection, plus men's colours on the men's pack sizes). On Add to cart the form
   is retargeted to the pack variant with properties[Colors] (and Pre-order when a
   pre-order colour is in the mix).
   ========================================================================== */
(function () {
  'use strict';
  var T = window.BM_I18N || {};
  var CW = window.BMCW;
  function tt(s, tok, val) { return String(s).replace(tok, val); }

  var $selector = document.querySelector('[data-pack-selector]');
  if (!$selector || !CW) return;

  var $packs = Array.prototype.slice.call($selector.querySelectorAll('[data-pack]'));
  var $picker = $selector.querySelector('[data-pack-picker]');
  var $rows = $selector.querySelector('[data-cw-rows]');
  var $sizeLabel = $selector.querySelector('[data-pack-size-label]');
  var $total = $selector.querySelector('[data-pack-total]');
  var $target = $selector.querySelector('[data-pack-target]');
  var $hint = $selector.querySelector('[data-pack-hint]');

  var $form = document.getElementById('bm-product-form');
  if (!$form) return;
  var $variantInput = $form.querySelector('[data-pdp-variant-id]') || $form.querySelector('input[name="id"]');
  var $atc = $form.querySelector('[data-pdp-atc]');
  var $priceEl = document.querySelector('[data-pdp-price]');
  if (!$variantInput || !$atc) return;

  var cur = CW.current();
  var curKey = cur ? cur.key : '';
  var atcDefaultLabel = $atc.textContent.trim() || T.addToCart || 'Add to cart';
  // Whether THIS sock is buyable on its own (in stock or on pre-order).
  var currentAvailable = $selector.getAttribute('data-current-available') !== 'false';

  var P = { row: 'bm-packs__picker-row', dot: 'bm-packs__dot', name: 'bm-packs__name', stepper: 'bm-packs__stepper', step: 'bm-packs__step', count: 'bm-packs__step-count', attr: 'data-pack' };

  var state = { pack: 'single', size: 1, variantId: $variantInput.value, priceCents: 0, label: 'Single', list: [], mix: {} };

  function formatMoney(cents) { return '$' + (Number(cents) / 100).toFixed(2); }
  function totalPicked() { return CW.total(state.mix); }

  var $boNote = null;
  function updateBoNote() {
    var ks = state.pack === 'single' ? [] : CW.backorderKeys(state.list, state.mix);
    if (ks.length) {
      if (!$boNote) {
        $boNote = document.createElement('p');
        $boNote.className = 'bm-backorder-note';
        if ($hint && $hint.parentNode) $hint.parentNode.insertBefore($boNote, $hint.nextSibling);
        else if ($picker) $picker.appendChild($boNote);
      }
      $boNote.textContent = CW.notice(ks);
      $boNote.hidden = false;
    } else if ($boNote) { $boNote.hidden = true; }
  }

  function updateAtcLabel() {
    if (state.pack === 'single') {
      if (!currentAvailable) {
        $atc.textContent = T.soldOut || 'Sold Out';
        $atc.disabled = true;
      } else {
        $atc.textContent = atcDefaultLabel;
        $atc.disabled = false;
      }
      return;
    }
    var n = totalPicked();
    if (n < state.size) {
      var remaining = state.size - n;
      $atc.textContent = T.pickMorePair ? tt(T.pickMorePair, '[n]', remaining) : ('Pick ' + remaining + ' more pair' + (remaining === 1 ? '' : 's'));
      $atc.disabled = true;
    } else if (n > state.size) {
      $atc.textContent = 'Remove ' + (n - state.size) + ' pair' + ((n - state.size) === 1 ? '' : 's');
      $atc.disabled = true;
    } else {
      $atc.textContent = (T.addLabel ? tt(T.addLabel, '[label]', state.label) : ('Add ' + state.label)) + ' · ' + formatMoney(state.priceCents);
      $atc.disabled = false;
    }
  }

  function updateHint() {
    updateBoNote();
    if (!$hint) return;
    var n = totalPicked();
    if (n === state.size) {
      $hint.textContent = '✓ ' + n + '/' + state.size + ' pairs picked · ' + (T.swapHint || 'tap + to swap a colour');
      $hint.classList.add('is-ready');
    } else if (n > state.size) {
      $hint.textContent = (n - state.size) + ' over, remove some';
      $hint.classList.remove('is-ready');
    } else {
      $hint.textContent = T.pickMoreContinue ? tt(T.pickMoreContinue, '[n]', state.size - n) : ('Pick ' + (state.size - n) + ' more to continue');
      $hint.classList.remove('is-ready');
    }
  }

  function renderPickerCounts() {
    var n = totalPicked();
    state.list.forEach(function (c) {
      var sold = c.soldout;
      var $count = $picker.querySelector('[data-pack-count="' + c.key + '"]');
      if ($count) $count.textContent = state.mix[c.key];
      var $row = $picker.querySelector('[data-pack-row="' + c.key + '"]');
      if ($row) {
        $row.classList.toggle('has-count', state.mix[c.key] > 0 && !sold);
        $row.classList.toggle('is-soldout', sold);
        if (sold && !$row.querySelector('.bm-packs__soldout')) {
          var badge = document.createElement('span');
          badge.className = 'bm-packs__soldout';
          badge.textContent = T.soldOut || 'Sold out';
          var $stepper = $row.querySelector('.bm-packs__stepper');
          if ($stepper) $row.insertBefore(badge, $stepper);
        }
      }
      var $minus = $picker.querySelector('[data-pack-minus="' + c.key + '"]');
      if ($minus) $minus.disabled = sold || state.mix[c.key] === 0;
      var $plus = $picker.querySelector('[data-pack-plus="' + c.key + '"]');
      if ($plus) $plus.disabled = sold || (n >= state.size && state.mix[c.key] >= n);
    });
    if ($total) $total.textContent = n;
  }

  function setPack($btn) {
    var pack = $btn.getAttribute('data-pack');
    var size = parseInt($btn.getAttribute('data-pack-size'), 10) || 1;
    state.pack = pack;
    state.size = size;
    state.priceCents = parseInt($btn.getAttribute('data-pack-price-cents'), 10) || 0;
    state.variantId = $btn.getAttribute('data-pack-variant') || '';
    state.label = $btn.getAttribute('data-pack-label') || 'Single';

    $packs.forEach(function ($p) {
      var on = $p === $btn;
      $p.classList.toggle('bm-pack--current', on);
      $p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    $variantInput.value = state.variantId;
    if ($priceEl) $priceEl.textContent = formatMoney(state.priceCents);

    if (pack === 'single') {
      if ($picker) $picker.hidden = true;
      removeColorsField();
    } else if ($picker && $rows) {
      state.list = CW.forSize(size);
      state.mix = CW.defaultMix(state.list, size, curKey);
      $rows.innerHTML = CW.rowsHTML(state.list, P);
      $picker.hidden = false;
      if ($sizeLabel) $sizeLabel.textContent = size;
      if ($target) $target.textContent = size;
      renderPickerCounts();
      writeColorsField();
    }
    updateAtcLabel();
    updateHint();
  }

  function changeColor(key, delta) {
    var c = CW.byKey(key);
    if (!c || !state.mix.hasOwnProperty(key)) return;
    if (delta > 0 && c.soldout) return;
    if (delta > 0 && totalPicked() >= state.size) {
      if (!CW.swapInto(state.list, state.mix, key)) return;
      renderPickerCounts(); writeColorsField(); updateAtcLabel(); updateHint(); return;
    }
    var next = state.mix[key] + delta;
    if (next < 0) return;
    state.mix[key] = next;
    renderPickerCounts();
    writeColorsField();
    updateAtcLabel();
    updateHint();
  }

  function removeColorsField() {
    var $existing = $form.querySelector('input[name="properties[Colors]"]');
    if ($existing) $existing.remove();
    var $bo = $form.querySelector('input[name="properties[Pre-order]"]:not([data-bo-static])');
    if ($bo) $bo.remove();
  }

  function writeColorsField() {
    var $existing = $form.querySelector('input[name="properties[Colors]"]');
    if (!$existing) {
      $existing = document.createElement('input');
      $existing.type = 'hidden';
      $existing.name = 'properties[Colors]';
      $form.appendChild($existing);
    }
    $existing.value = CW.colorsString(state.list, state.mix);
    var ks = state.pack === 'single' ? [] : CW.backorderKeys(state.list, state.mix);
    var $bo = $form.querySelector('input[name="properties[Pre-order]"]:not([data-bo-static])');
    if (ks.length) {
      if (!$bo) {
        $bo = document.createElement('input');
        $bo.type = 'hidden';
        $bo.name = 'properties[Pre-order]';
        $form.appendChild($bo);
      }
      $bo.value = CW.property(ks);
    } else if ($bo) { $bo.remove(); }
    // A bundle never carries the single sock's own pre-order note.
    var $static = $form.querySelector('input[name="properties[Pre-order]"][data-bo-static]');
    if ($static) $static.disabled = state.pack !== 'single';
  }

  $packs.forEach(function ($btn) {
    $btn.addEventListener('click', function (e) { e.preventDefault(); setPack($btn); });
  });

  if ($picker) {
    $picker.addEventListener('click', function (e) {
      var $btn = e.target.closest('button');
      if (!$btn) return;
      e.preventDefault();
      if ($btn.hasAttribute('data-pack-plus')) changeColor($btn.getAttribute('data-pack-plus'), 1);
      else if ($btn.hasAttribute('data-pack-minus')) changeColor($btn.getAttribute('data-pack-minus'), -1);
    });
  }

  $form.addEventListener('submit', function (e) {
    if (state.pack !== 'single' && totalPicked() !== state.size) { e.preventDefault(); return false; }
  });

  updateAtcLabel();
})();
